export default {

  // set items
  setItems(state, items) {
    state.items = items;
  },

  // set items remaining
  setItemsRemaining(state, itemsRemaining) {
    state.itemsRemaining = itemsRemaining;
  },

  // set item count
  setItemsCount(state, itemsCount) {
    state.itemsCount = itemsCount;
  },

  // set all the filters
  setFilters(state, filters) {
    state.filters = filters;
  },

  setFilterSelected(state, data) {
    state.filters[data.filterKey].children[data.itemKey].selected = data.checked;
  },

  // toggle all the filters
  setAllFiltersSelected(state, selected) {
    state.filters.forEach(filter => {
      filter.children.forEach(item => {
        item.selected = selected;
      });
    });
  },

  // set sort order options
  setSortOrderOptions(state, sortOrderOptions) {
    state.SortOrderOptions = sortOrderOptions;
  },

  // set the sort order
  setSortOrder(state, sortOrder) {
    state.SortOrder = sortOrder;
  },

  // set the search term
  setSearchTerm(state, searchTerm) {
    state.q = searchTerm;
  },

  // set the q search term
  setq(state, searchTerm) {
    state.q = searchTerm;
  },

  // set the current search term
  setCurrentSearch(state, currentSearch) {
    state.CurrentSearch = currentSearch;
  },

  // set the current page
  setCurrentPage(state, currentPage) {
    state.currentPage = currentPage;
  },

  // set the total pages
  setTotalPages(state, totalPages) {
    state.totalPages = totalPages;
  },

  // set loading
  setLoading(state, loading) {
    state.loading = loading;
  },

  // the amount of results we need to take from the API
  setTake(state, take) {
    take = parseInt(take) || 0;
    if (take < state.initialTake) {
      take = state.initialTake;
    }
    state.Take = take;
  },

  // the amount of results we need to take from the API (when resetting)
  setInitialTake(state, initialTake) {
    state.initialTake = parseInt(initialTake);
  },

  // which result we load from
  setFrom(state, from) {
    state.From = parseInt(from) || 0;
  },

  // the parent page id from umbraco (used in api calls if set)
  setParentId(state, parentId) {
    state.parentId = parentId;
  },

  // set the tag
  setTag(state, tag) {
    state.Tag = tag;
  },

  setChildItemsOnly(state, childItems) {
    state.childItemsOnly = childItems;
  },

  setIsSiteSearch(state, isSiteSearch) {
    state.isSiteSearch = isSiteSearch;
  },

  showNoResultsContent(state, noResultsContent) {
    state.showNoResultsContent = noResultsContent;
  },

  // global set query param mutation (fallback)
  // we set the filters as selected
  setQueryParam(state, data) {
    // if the value is blank, dont set anything
    if (!data.value) {
      return;
    }

    // create a filters array if its not there
    if (!state.filters) {
      state.filters = [];
    }

    // get/create the filter
    let filter = state.filters.find(filter => filter.value === data.attribute);
    if (!filter) {
      filter = {
        value: data.attribute,
        children: []
      };
      state.filters.push(filter);
    }

    // ensure the filter values are an array
    if (typeof data.value === 'string') {
      data.value = [data.value];
    }

    // handle range values
    if (typeof data.value === 'object' && !Array.isArray(data.value) && data.value !== null) {
      filter.type = 'Range';
      filter.children.push({
        to: parseFloat(data.value.To),
        selected: true
      });
      filter.children.unshift({
        from: parseFloat(data.value.From),
        selected: true
      });
    }

    // handle value values
    else {
      // loop each filter value from the query
      data.value.forEach(value => {
        // get/create the filter item
        let item = filter.children.find(item => item.value === value);
        if (!item) {
          item = {
            value: value
          };
          filter.children.push(item);
        }

        // set each filter as selected
        item.selected = true;
      });
    }
  }
};